import React, { useState } from "react";
import CommonIconView from "presentational/common/CommonIconView";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { sleep } from "lib/commonUtil";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;

const TOOLTIP_MILLISEC = 2000;

const css = {
  base: {
    width: 26,
    height: 26,
    borderRadius: "20%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    cursor: "help",
    userSelect: "none",
    color: "#777777"
  },
  withBox: {
    color: "#555555",
    backgroundColor: "#ffffff",
    border: "1px solid #d8d8d8"
  },
  icon: {
    fontSize: 17,
    zIndex: 1
  }
};

const TitleTypography = withStyles({
  root: {
    fontSize: 12,
    fontWeight: fontCss.bold
  }
})(Typography);

PrivateMarkIconView.propTypes = {
  isItemListPublic: PropTypes.bool.isRequired,
  displayPrivateOnly: PropTypes.bool,

  /**
   * removeBorder: 챗지피티가 만들어줘서 저장은 했는데, 없는게 미니멀해서 좋드라.
   */
  removeBorder: PropTypes.bool
};

PrivateMarkIconView.defaultProps = {
  displayPrivateOnly: false,
  removeBorder: false
};

function PrivateMarkIconView(props) {
  const { isItemListPublic, displayPrivateOnly, removeBorder } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  if (displayPrivateOnly && isItemListPublic) return null;

  const handleClick = async () => {
    if (tooltipOpen) return null;
    setTooltipOpen(true);
    await sleep(TOOLTIP_MILLISEC);
    setTooltipOpen(false);
  };

  const getTitle = () => {
    return isItemListPublic ? (
      <TitleTypography>
        <TXT name="msg_nowPublic" />: <TXT name="msg_publicItemDetail" />
      </TitleTypography>
    ) : (
      <TitleTypography>
        <TXT name="msg_nowPrivate" />: <TXT name="msg_privateItemDetail" />
      </TitleTypography>
    );
  };

  return (
    <Tooltip
      open={tooltipOpen}
      title={getTitle()}
      placement="bottom"
      disableFocusListener
      disableHoverListener
      disableTouchListener
      arrow
    >
      <div
        style={Object.assign({}, css.base, removeBorder ? {} : css.withBox)}
        onClick={handleClick}
      >
        <CommonIconView
          type={isItemListPublic ? "public" : "private"}
          fontSize={"inherit"}
          style={css.icon}
        />
      </div>
    </Tooltip>
  );
}

export default PrivateMarkIconView;
